import { memo } from 'react';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import CustomFieldTextIcon from '../../../../../../shared/icons/icons-revamp/custom_field_text';
import CustomFieldNumberIcon from '../../../../../../shared/icons/icons-revamp/custom_field_number';
import CustomFieldDateIcon from '../../../../../../shared/icons/icons-revamp/custom_field_date';
import CustomFieldSingleSelectIcon from '../../../../../../shared/icons/icons-revamp/custom_field_single_select';
import CustomFieldMultiSelectIcon from '../../../../../../shared/icons/icons-revamp/custom_field_multi_select';
import { CustomFieldDataType } from './typings';

interface Props {
  dataType: CustomFieldDataType;
  size?: number;
  color?: string;
}

const DataTypeIcon = ({ dataType, size = 16, color = '#7A7A7A' }: Props) => {
  if (dataType === 'text') return <CustomFieldTextIcon size={size} color={color} />;
  if (dataType === 'number') return <CustomFieldNumberIcon size={size} color={color} />;
  if (dataType === 'date') return <CustomFieldDateIcon size={size} color={color} />;
  if (dataType === 'single_select') return <CustomFieldSingleSelectIcon size={size} color={color} />;
  if (dataType === 'multi_select') return <CustomFieldMultiSelectIcon size={size} color={color} />;
  if (dataType === 'boolean') return <ToggleOnOutlinedIcon sx={{ fontSize: size, color }} />;
  return null;
};

export const dataTypeLabel = (dataType: CustomFieldDataType): string => {
  if (dataType === 'text') return 'Text';
  if (dataType === 'number') return 'Number';
  if (dataType === 'date') return 'Date';
  if (dataType === 'single_select') return 'List';
  if (dataType === 'multi_select') return 'Multi-select list';
  if (dataType === 'boolean') return 'Boolean';
  return dataType;
};

export default memo(DataTypeIcon);
